import type { IngestionSourceSummary, SetIngestionKeyEnabledPayload } from '@jums-dashboard/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { callFunction } from '@/lib/callableClient';

import { ingestionSourcesQueryKey } from './useIngestionSources';

export default function useSetIngestionKeyEnabled() {
  const qc = useQueryClient();
  return useMutation<IngestionSourceSummary, Error, SetIngestionKeyEnabledPayload>({
    mutationFn: (payload) => callFunction<SetIngestionKeyEnabledPayload, IngestionSourceSummary>('setIngestionKeyEnabledCallable', payload),
    onSuccess: (_data, vars) => {
      toast.success(vars.enabled ? 'Ingestion key enabled.' : 'Ingestion key disabled.');
      void qc.invalidateQueries({ queryKey: ingestionSourcesQueryKey(vars.homeId) });
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to update ingestion key.');
    },
  });
}
